<template>
  <div class="kbli-container">
    <div class="modal-company-kbli-wrapper">
      <div class="column100 flex-row">
        <div class="text-bold column5">No</div>
        <div class="text-bold column10">Kode</div>
        <div class="text-bold column40">Kualifikasi</div>
        <div class="text-bold column20">Klasifikasi</div>
        <div class="text-bold column20">Sub Klasifikasi</div>
      </div>
      <div
        class="column100 flex-row mt10"
        v-if="sbujkVendor.length > 0"
        v-for="(list, index) in sbujkVendor"
        :key="index"
      >
        <div class="column5">{{ index + 1 }}</div>
        <div class="column10">{{ list.master_sbujk.kode }}</div>
        <div class="column40">{{ list.master_sbujk.kualifikasi }}</div>
        <div class="column20">{{ list.master_sbujk.klasifikasi }}</div>
        <div class="column20">{{ list.master_sbujk.sub_klasifikasi }}</div>
      </div>
    </div>

    <div class="kbli-mobile-container for-mobile">
      <div
        class="kbli-mobile-list"
        v-if="sbujkVendor.length > 0"
        v-for="(list, index) in sbujkVendor"
        :key="index"
      >
        <div class="w-full text-gray">Kode</div>
        <div class="w-full">{{ list.master_sbujk.kode }}</div>
        <div class="w-full text-gray">Kualifikasi</div>
        <div class="w-full">{{ list.master_sbujk.kualifikasi }}</div>
        <div class="w-full text-gray">Klasifikasi</div>
        <div class="w-full">{{ list.master_sbujk.klasifikasi }}</div>
        <div class="w-full text-gray">Sub Klasifikasi</div>
        <div class="w-full">{{ list.master_sbujk.sub_klasifikasi }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    sbujkVendor() {
      return this.$store.state.level1.sbujkVendor
    },
  },
  created() {},
  methods: {},
}
</script>
